import { INITIALIZE_USER, LOGOUT } from '../user/types';
import { USER_AUTH_TICKET } from './types';
const initialState = {
  loggedIn: false,
  token: ''
};
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_USER:
      return {
        ...state,
        loggedIn: true
      };
    case LOGOUT:
      return initialState;
    case USER_AUTH_TICKET:
      return {
        ...state,
        token: action.token
      };
    default:
      return state;
  }
};